<div
  *ngIf="parentFormGroup.controls[controlName]"
  class="font-work-sans font-regular"
>
  <div
    class="form-field-label {{type}}"
    *ngIf="label"
  >
    {{label}}
    <span
      *ngIf="isRequired"
      class="required-mark"
    >*</span>
  </div>
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="outline"
    class="form-field w-full"
    [ngClass]="type ? 'small' : ''"
    hideRequiredMarker
  >
    <input
      #input
      class="input {{type}} date-input"
      [formControlName]="controlName"
      [matDatetimepicker]="dts"
      [required]="isRequired"
      [max]="max"
      [min]="min"
      autocomplete="false"
      placeholder="{{placeholder}}"
      matInput
    >
    <mat-icon matPrefix matRipple svgIcon="calender"></mat-icon>
    <mat-datetimepicker #dts [openOnFocus]="true" type="time"></mat-datetimepicker>
    <mat-error *ngIf="error">{{error}}</mat-error>
  </mat-form-field>
</div>
